// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { common } from '../../tokens/primitiveColors/common';
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { inverseBackground, inverseIcon } from '../../tokens/themeColors/inverse';
import { text } from '../../tokens/themeColors/text';
export var switchColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    var inverseIc = inverseIcon(mode);
    var inverseBg = inverseBackground(mode);
    return {
        default: {
            // Figma defines no Default/Background card for Switch — the track
            // is transparent (border-only) in the off position.
            background: common.transparent,
            border: bd.default,
            knob: ic.active,
            labelText: tx.primary
        },
        checked: {
            knob: inverseIc.active,
            knobBackground: inverseBg.level100
        },
        disabled: {
            background: bg.state.disabled2,
            knob: ic.disabled,
            labelText: tx.disabled
        },
        focus: {
            border: bd.actionBold
        },
        hover: {
            background: bg.state.hover0,
            border: bd.heavy
        }
    };
};

//# sourceMappingURL=switchColors.js.map